module.exports = __webpack_public_path__ + "img/gametitle.b9d77836.jpg";